// extracted by mini-css-extract-plugin
export default {"overlay":"PaymentSuccess_overlay__lCLZ0","modal":"PaymentSuccess_modal__IbmRb","title":"PaymentSuccess_title__+83Hv","mainButton":"PaymentSuccess_mainButton__xmtCw"};